import { productName } from "./productIdentity";

export type AgencyBranding = {
  displayName: string;
  logoAssetRef?: string;
  logoAltText?: string;
};

/** The safe copy shown before a route has resolved its agency context. */
export const genericAgencyBranding: AgencyBranding = {
  displayName: productName,
};

/** Local/demo configuration for the current agency, backed by the exact committed PNG asset. */
export const pavlovaComBranding: AgencyBranding = {
  displayName: "Pavlova com",
  logoAssetRef: "/branding/pavlova-com-logo.png",
  logoAltText: "Pavlova com logo",
};

export function normalizeAgencyBranding(value: Partial<AgencyBranding> | null | undefined): AgencyBranding {
  const displayName = value?.displayName?.trim();
  const logoAssetRef = value?.logoAssetRef?.trim() || undefined;
  const logoAltText = value?.logoAltText?.trim() || undefined;
  return {
    displayName: displayName || genericAgencyBranding.displayName,
    ...(logoAssetRef ? { logoAssetRef } : {}),
    ...(logoAltText ? { logoAltText } : {}),
  };
}

export function applyAgencyFavicon(value: Partial<AgencyBranding> | null | undefined) {
  if (typeof document === "undefined") return;
  const branding = normalizeAgencyBranding(value);
  const link = document.head.querySelector<HTMLLinkElement>("link[data-agency-favicon], link[rel~='icon']")
    ?? document.head.appendChild(document.createElement("link"));
  link.rel = "icon";
  link.dataset.agencyFavicon = "true";
  link.href = branding.logoAssetRef ?? "/favicon.svg";
  link.type = branding.logoAssetRef?.toLowerCase().endsWith(".png") ? "image/png" : "image/svg+xml";
}
